import store from "../store";
import { IAppState } from "../store/appSlice";
import { toast } from 'react-toastify';
import Ajv from 'ajv';
import { IUserConnected, IUserState } from "../store/userSlice";
// @ts-ignore
import CryptoJS from "crypto-js";
import { IEtabActivetedWebService } from "../Xserver/Services/interface";
import { secret } from "./constant";

// Définition d'une interface pour ton item
export interface IServiceItem {
  idService: string;
  config: string; // crypté ou JSON string
  codeEtab: string;
  anneeScolaire: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any; // si d’autres champs dynamiques
}

// fonction pour définir si on est en mode dev ou prod
export const isDev = () => !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const getServerUrl = () => {
  const appState = store?.getState()?.application as IAppState;
  return appState.serverUrl;
};

//fonction pour notifier les actions reussies
export const successNotify = (responseMessage: string) =>
  toast.success(responseMessage, {
    position: 'bottom-left',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });

//fonction pour notifier les actions echouées
export const infoNotify = (responseMessage: string) =>
  toast.info(responseMessage, {
    position: 'bottom-left',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });

//fonction pour notifier les actions echouées
export const errorNotify = (responseMessage: string) =>
  toast.error(responseMessage, {
    position: 'bottom-left',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });

export const warningNotify = (responseMessage: string) =>
  toast.warning(responseMessage, {
    position: 'bottom-left',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });

export const ajvValidator = (schema: any, data: any) => {
  const ajvInstance = new Ajv({ allErrors: true });
  require('ajv-errors')(ajvInstance);
  const validate = ajvInstance.compile(schema);
  const valid = validate(data);
  if (!valid) {
    const errors = validate.errors;
    return { status: 0, errors };
  } else {
    return { status: 1 };
  }
};



export const convertToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};


export const formatDate = (date: any) => {
  return new Date(date).toLocaleString(
    "fr-FR",
    {
      timeZone: "UTC",
      month: "numeric",
      day: "numeric",
      year: "numeric"
    }
  )
} 

export const formatDateHeure = (date: any) => {
  return new Date(date).toLocaleString(
    "fr-FR",
    {
      timeZone: "UTC",
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric"
    }
  )
}


export const getMonthNumberFromDate = (date: any) => {
  if (!(date instanceof Date)) {
    throw new Error("L'argument doit être une instance de Date");
  }
  const month = date.getMonth(); // Cette méthode retourne le numéro du mois (0-11)
  const monthNumber = month + 1; // Ajoute 1 pour obtenir un numéro de mois de 1 à 12
  return monthNumber;
}

export const userHasRight = (right: string) => {
  const newUser = store?.getState()?.users as IUserState;
  if (newUser.userConnected !== null && newUser.userConnected.user?.idTypeUtilisateur === 1) return true;
  return newUser.userConnected !== null && newUser.userConnected.userRights?.includes(right);
};

//avoir le libellé du mois précédent
export const getPrecedentMois = () => {
  const mois = new Date();
  mois.setMonth(mois.getMonth()-1);
  // mois.setMonth(mois.getMonth());
  switch (mois.getMonth()) {
    case 0:
      return "de Janvier";
      break;
    case 1:
      return "de Février";
      break;
    case 2:
      return "de Mars";
      break;
    case 3:
      return "d'Avril";
      break;
    case 4:
      return "de Mai";
      break;
    case 5:
      return "de Juin";
      break;
    case 6:
      return "de Juillet";
      break;
    case 7:
      return "d'Aûot";
      break;
    case 8:
      return "de Septembre";
      break;
    case 9:
      return "d'octobre";
      break;
    case 10:
      return "de novembre";
      break;
    case 11:
      return "de Décembre";
      break;
  }
};

